import { Component } from '@angular/core';

@Component({
    selector: 'app-terms-of-service',
    templateUrl: './terms-of-service.component.html',
    styleUrls: ['./terms-of-service.component.css'],
    standalone: false
})
export class TermsOfServiceComponent {

}
